export default "__VITE_ASSET__0a41a502__"